/**
 * Generated from ch7_p02.fla
 */
export function ch7_p02(this: Ich7_p02) {
	const bg = this.bg;
	ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const horse = this.horse;
	ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_horse.call(this.horse);
	horse.x = 1292.25;
	horse.y = 768;
	horse.width = 360.50;
	horse.height = 224.00;
	horse.alpha = 1.00;
	if (horse.onLayout) horse.onLayout();
	const holly = this.holly;
	ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_holly.call(this.holly);
	holly.x = 592.5;
	holly.y = 768;
	holly.width = 575.00;
	holly.height = 733.00;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const frameRight = this.frameRight;
	ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 353.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframerlines.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 342.25;
	linesRight.width = 109.50;
	linesRight.height = 280.50;
	linesRight.alpha = 0.50;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 343.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframellines.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 297;
	linesLeft.width = 144.00;
	linesLeft.height = 408.00;
	linesLeft.alpha = 0.50;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_bg(this: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p02_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_horse(this: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p02_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_holly(this: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp7_p02_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframeRframe(this: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframerlines(this: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframerlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframeLframe(this: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframellines(this: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframellines) {
	if (this.setLayoutTexture) this.setLayoutTexture("llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich7_p02Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich7_p02Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich7_p02Sprite extends Ich7_p02Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich7_p02Text extends Ich7_p02Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich7_p02Polygon extends Array<number> {
}
interface Ich7_p02 {
	readonly bg: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_bg;
	readonly horse: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_horse;
	readonly holly: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_holly;
	readonly frameRight: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframeRframe;
	readonly linesRight: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframerlines;
	readonly frameLeft: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframeLframe;
	readonly linesLeft: Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframellines;
}
interface Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_bg extends Ich7_p02Sprite {
}
interface Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_horse extends Ich7_p02Sprite {
}
interface Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_holly extends Ich7_p02Sprite {
}
interface Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframeRframe extends Ich7_p02Sprite {
}
interface Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframerlines extends Ich7_p02Sprite {
}
interface Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframeLframe extends Ich7_p02Sprite {
}
interface Ich7_p02_hh_ch7_72dpi_p02psdAssetchp7_p02_wcframellines extends Ich7_p02Sprite {
}
